import { render, staticRenderFns } from "./studytrain.vue?vue&type=template&id=1d64b9ee&scoped=true&"
import script from "./studytrain.vue?vue&type=script&lang=js&"
export * from "./studytrain.vue?vue&type=script&lang=js&"
import style0 from "./studytrain.vue?vue&type=style&index=0&id=1d64b9ee&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64b9ee",
  null
  
)

export default component.exports